<script>
  import Test from "../ponents/Test.svelte";
  import { navigate, Link } from "svelte-routing";

  let test;

  import Store from "../stores/Store";
  let answers;
  Store.subscribe((data) => {
    answers = data;
  });

  function handIn() {
    if (areAnswersTruthful && isCaptchaComplete) {
      fetch("/api/database-write", {
        method: "POST",
        headers: {
          "captcha-token": captchaToken ?? "",
        },
        body: JSON.stringify(answers),
      });
    }
    navigate(
      `/results?` +
        Object.entries(test.scores())
          .map(([k, v]) => encodeURIComponent(k) + "=" + encodeURIComponent(v))
          .join("&")
    );
  }

  import { adsConfig } from "../stores/Store";
  import { onMount } from "svelte";
  onMount(() => {
    adsConfig.set({
      footerBanner: false,
      interstitial: false,
    });
  });

  //

  import { Recaptcha, recaptcha, observer } from "svelte-recaptcha-v2";
  /*
  │Recaptcha: svelte <Recaptcha> component.
  │recaptcha: google method, gives you recaptcha.execute().
  │observer: allows you to track captcha state across components.
  */
  const googleRecaptchaSiteKey = "6LdZH08rAAAAAIQXf27nFA5x22ZBBmdhrWb2gh94";

  let isCaptchaComplete = false;
  let areAnswersTruthful = true;
  $: submitButtonText =
    isCaptchaComplete && areAnswersTruthful
      ? "Submit and Go to Results"
      : "Go to Results";

  let captchaToken;

  function onCaptchaComponentMount() {
    console.log("recaptcha mounted.");
  }

  const onCaptchaReady = (event) => {
    console.log("recaptcha init has completed.");
    /*
     │You can enable your form button here.
    */
  };
  const onCaptchaSuccess = (event) => {
    // userTracker.resolve(event);
    console.log("recaptcha success.");
    captchaToken = event.detail.token;
    /*
     │If using checkbox method, you can attach your
     │form logic here, or dispatch your custom event.
    */
    isCaptchaComplete = true;
  };
  const onCaptchaError = (event) => {
    console.error("recaptcha init has failed.");
    /*
     │Usually due to incorrect siteKey.
     |Make sure you have the correct siteKey..
    */
  };
  const onCaptchaExpire = (event) => {
    console.log("recaptcha api has expired");
    /*
     │Normally, you wouldn't need to do anything.
     │Recaptcha should reinit itself automatically.
    */
    isCaptchaComplete = false;
  };

  let recaptchaInstance;
</script>

<svelte:head>
  <title>27types</title>
</svelte:head>

<header>
  <section>
    <h1 class="mb-2"><em>27types</em></h1>
    <div role="doc-subtitle" class="lead mb-3">
      The <em>27types</em> Life Archetypes Test : A Combo of Rice Purity and MBTI
    </div>
    <p>
      <em>27types</em> is an un-innocence test that’s like
      <em>The Rice Purity Test</em>
      with reverse scoring.
      <em>27types</em>’s test is more advanced than
      <em>The Rice Purity Test</em> is because our test has 3 sections, the scores
      of which are used to classify your results into 1 of 27 archetypes. Archetypes
      have 3-letter codes just like the Meyers–Briggs personality types have 4-letter
      codes.
    </p>
  </section>
  <section>
    <Link to="/catalog">
      <button class="btn btn-warning shadow-sm">View The 27 Types</button>
    </Link>
    <Link to="/statistics">
      <button class="btn btn-info shadow-sm">Explore Statistics</button>
    </Link>
  </section>
  <div>
    Take the test below. It consists of questions about (1) your romantic and
    sexual experiences, (2) illicit, unethical, and naughty things you’ve done,
    and (3) your social experiences. Each of the 3 sections is scored out of 100
    points.
  </div>
</header>

<Test bind:this={test} />

<div class="alert alert-light shadow mb-3" role="alert">
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      id="truthful"
      bind:checked={areAnswersTruthful}
    />
    <label for="truthful">
      Check this box if your answers are <strong>honest</strong> and you want
      your submission to affect the <em>statistics</em>. If you’re just messing
      around to see what result you’ll get with joke answers, please don’t check
      this box.
    </label>
  </div>
</div>

<footer>
  <div
    class="mb-3 d-flex flex-row justify-content-center {isCaptchaComplete
      ? 'd-none'
      : ''}"
    data-captcha="true"
  >
    <Recaptcha
      bind:this={recaptchaInstance}
      sitekey={googleRecaptchaSiteKey}
      size={"normal"}
      on:success={onCaptchaSuccess}
      on:error={onCaptchaError}
      on:ready={onCaptchaReady}
      on:expired={onCaptchaExpire}
    />
  </div>
  {#if isCaptchaComplete}
    <div class="mb-3">
      <small style="color: green;">Verification Successful.</small>
    </div>
  {/if}
  {#if areAnswersTruthful && !isCaptchaComplete}
    <div class="mb-2">
      <small
        >You need to check the "I’m not a robot" checkbox or your answers won’t
        be submitted.</small
      >
    </div>
  {/if}
  <div>
    <button class="btn btn-success btn-lg shadow" on:click={handIn}
      >{submitButtonText}</button
    >
  </div>
</footer>
